<template>
  <li>
    <div class="row">
      <div class="col flex-grow-1">
        <div class="form-check">
          <input
            v-bind="{ id, checked, value: severity }"
            type="checkbox"
            class="form-check-input"
            @input="updateValue"
          />
          <label :for="id" class="form-check-label">
            {{ label }}
          </label>
        </div>
      </div>
      <div class="col-auto">
        <div :class="`chip chip-${severityClass}`">{{ count }}</div>
      </div>
    </div>
  </li>
</template>

<script>
import { upperFirst } from 'lodash'

export default {
  props: {
    value: Array,
    severity: String,
    count: Number
  },

  computed: {
    severityClass () {
      switch (this.severity) {
        case 'critical':
          return 'dark'
        case 'high':
          return 'danger'
        case 'moderate':
          return 'warning'
        case 'low':
          return 'light'
      }
    },

    label () {
      return `${upperFirst(this.severity)} severity`
    },

    id () {
      return `checkbox-severity-${this.severity}`
    },

    checked () {
      return this.value.includes(this.severity)
    }
  },

  methods: {
    updateValue (event) {
      if (event.target.checked) {
        this.$emit('input', [].concat(this.value, this.severity))
      } else {
        this.$emit('input', [].concat(this.value).filter(severity => severity !== this.severity))
      }
    }
  }
}
</script>
